import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../../../context/AuthContext';


const EditRestaurantData = ({ onSubmit, resData }) => {
// console.log(restaurantDetailsId);
const { apiGlobal } = useContext(AuthContext);
const [country, setCountry] = useState([]);
const [selectCountry, setSelectCountry] = useState({
    value: resData.country,
    label: resData.country_name,
   });
    const [selectCountryCode, setSelectCountryCode] = useState({
    value: resData.country_code_id,
    label: resData.country_code,
   });
    const [selectAccountCountry, setSelectAccountCountry] = useState({
    value: resData.acc_country,
    label: resData.acc_country_name,
   });

    const [selectedImage, setSelectedImage] = useState(`${apiGlobal}images/restaurant/${resData.photo}`);
    // const [isLoading, setIsLoading] = useState(true);
    // const [prevData, setPrevData] = useState(null);

    // const fetchRestaurantData = async () => {
    //     try {
    //        const url = await 
    //        fetch(`${apiGlobal}restaurant_data_fetch.php?id=${restaurantId}`);
    //         const data = await url.json();
    //         console.log(data);
    //         if (data.status && data.message === 'Success') {
    //             setPrevData(data.data[0]);
    //             setSelectedImage(`${apiGlobal}images/restaurant/${data.data[0].photo}`);
    //             setIsLoading(false);
    //         }
    //     } catch (error) {
    //         console.error('Error loading meals', error);
    //     }
    // };

    // useEffect(() => {
    //     fetchRestaurantData();
    // }, [restaurantId]);

  
  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
  
      input.onChange(file);
    } else {
      setSelectedImage(null);
      input.onChange(null);
    }
  };


  const fetchCountryList = async () => {
        try {
          const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
            method: 'POST',
          });
          const response = await url.json();
          if (response.status && response.message === 'Success') {
            setCountry(response?.data);
          } else {
            setCountry([]);
          }
        } catch (error) {
          console.log(error);
        } 
      };
    
      useEffect(() => {
        fetchCountryList();
      }, []);

//   if (isLoading) {
//     return <p>Loading...</p>;
//   }

  // console.log(prevData);

  return (
    <Col md={12} lg={12}>
      <Form onSubmit={onSubmit} initialValues={resData}>
        {({ handleSubmit, form }) => (
          <FormContainer onSubmit={handleSubmit}>
            {/* Primary Contact Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle />
                  <p><span style={{ color: 'red' }}>*{' '}</span>Marks Fields are Required</p>
                </CardTitleWrap>
                {/* First Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="user_name"
                          component="input"
                          type="text"
                          placeholder="Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="country_code_id"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                                          value: item.id,
                                                          label: item.country_code,
                                                        }))}
                                  value={selectCountryCode}
                                  onChange={(selected) => {
                                    setSelectCountryCode(selected);
                                    input.onChange(selected.value);
                                  }}
                                                            // isLoading={isLoading}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    // borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                          )}
                              </div>
                                                    )}
                          />
                        
                          {/* Phone Input */}
                          <Field
                            name="user_phone"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                                            // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  // borderRadius: '5px',
                                  // border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                      )}
                              </div>
                                                    )}
                          />
                        </div>
                        {/* <Field
                          name="user_phone"
                          component={renderMaskedField}
                          mask={[/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                          type="test"
                          placeholder="Phone Number"
                          required
                          style={{ height: '45px' }}
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Second Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="user_email"
                          component="input"
                          type="email"
                          placeholder="Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>UINs #<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uin"
                          component="input"
                          type="number"
                          placeholder="UIN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    
                  </Col>
                  
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                              style={{ height: '45px' }}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {selectedImage && (
                      <FormGroup>
                        <FormGroupLabel>Selected Logo</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedImage}
                            alt="Selected Logo"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                            required
                          />
                        </FormGroupField>
                      </FormGroup>
                    )}  
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              value={selectCountry}
                              onChange={(selected) => {
                                    setSelectCountry(selected);
                                    input.onChange(selected.value);
                                  }}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                  width: '100%',
                              control: provided => ({
                                ...provided,
                              }),
                              singleValue: provided => ({
                                ...provided,
                                
                              }),
                            }}
                            />
                                          )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Account Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle>Account Details</CardTitle>
                </CardTitleWrap>
                {/* Third Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="acc_name"
                          component="input"
                          type="text"
                          placeholder="Account Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="acc_country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="acc_country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              value={selectAccountCountry}
                              onChange={(selected) => {
                                    setSelectAccountCountry(selected);
                                    input.onChange(selected.value);
                                  }}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                  width: '100%',
                              control: provided => ({
                                ...provided,
                                
                              }),
                              singleValue: provided => ({
                                ...provided,
                                
                              }),
                            }}
                            />
                            )}
                        />
                        {/* <Field
                          name="acc_country"
                          component="input"
                          type="text"
                          placeholder="Country"
                          required
                          style={{ height: '45px' }}
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fourth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="account_no"
                          component="input"
                          type="number"
                          placeholder="Account Number"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="acc_city"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fifth Row: 2 columns */}
                <Row>
                  {!resData.account_no && (
                    <Col md={6}>
                      <FormGroup>
                        <FormGroupLabel>
                          Confirm Account <span style={{ color: 'red' }}>*</span>
                        </FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="conAccount"
                            component="input"
                            type="number"
                            placeholder="Confirm Account"
                            required
                            style={{ height: '45px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                    </Col>
                )}
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Branch<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="branch"
                          component="input"
                          type="text"
                          placeholder="Branch"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Sixth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>IFSC<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="ifsc_code"
                          component="input"
                          type="text"
                          placeholder="IFSC"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Bank<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="bank"
                          component="input"
                          type="text"
                          placeholder="Bank"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <FormButtonToolbar style={{ float: 'right' }}>
              <Button variant="primary" type="submit">Submit</Button>
            </FormButtonToolbar>
          </FormContainer>
      )}
      </Form>
    </Col>
);
};

EditRestaurantData.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  resData: PropTypes.shape({
    user_name: PropTypes.string.isRequired,
    user_phone: PropTypes.string.isRequired,
    user_email: PropTypes.string.isRequired,
    country_name: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    uin: PropTypes.string.isRequired,
    photo: PropTypes.string.isRequired,
    acc_name: PropTypes.string.isRequired,
    acc_country: PropTypes.string.isRequired,
    acc_country_name: PropTypes.string.isRequired,
    account_no: PropTypes.string.isRequired,
    acc_city: PropTypes.string.isRequired,
    branch: PropTypes.string.isRequired,
    ifsc_code: PropTypes.string.isRequired,
    bank: PropTypes.string.isRequired,
    country_code: PropTypes.string.isRequired,
    country_code_id: PropTypes.string.isRequired,

  }).isRequired,
};

export default EditRestaurantData;
